export default __webpack_public_path__ + "static/media/serventLeader_icon.3472fbfd.webp";